
import Lottie from "lottie-react";
import HighFive from "../../workout/animations/high-five.json";
import CustomButton from "../../../common/CustomButton";

function SlidePreProgram({ moveNext }) {
    return (
        <div id="uo-pre-program" className="uo-component div-45-55">
            <div id="uo-pp-banner">
                <div id="uo-pp-b-container">
                    <img src="/assets/images/onboarding/onboarding-device.png" className="pp-banner" />
                </div>
            </div>

            <div id="uo-pp-text" className="bottom-text-area">
                <h4>Let’s Choose Programs!</h4>
                <h6>We’ve chosen some programs we think you’ll love. Take a look at our recommendations and choose the programs that you’d like to add to your schedule. </h6>
                <CustomButton className="uo-button active" onClick={moveNext}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SlidePreProgram;